// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";

import { useEffect, useRef } from "react";

// rellax
import Rellax from "rellax";

// typed-js
import Typed from "typed.js";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";

// Material Kit 2 PRO React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import FMPFooter from "examples/Footers/FMPFooter";
import ColoredBackgroundCard from "examples/Cards/BackgroundCards/ColoredBackgroundCard";
import InfoBackgroundCard from "examples/Cards/BackgroundCards/InfoBackgroundCard";

// AcademiaCiber page sections
import abanav from "layouts/sections/navigation/nav-tabs/components/TabsSimple";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/ICEMBA-bg.jpg";
import StatsOne from "./components/Estatisticas";
import Testimonials from "./sections/Testimonials";
import ICEMBAStructure from "./sections/ICEMBAStructure";
import Requirements from "./sections/Requirements";
import image1 from "assets/images/requisitos.jpg";
import image2 from "assets/images/logos/lancaster-university-logo.jpg";
import image3 from "assets/images/estrutura.jpg";
import image4 from "assets/images/depoimentos.jpg";

function Icemba() {
  
  const scrollToRequisitos = () => {
    const section = document.getElementById("requisitos");
    section.scrollIntoView({ behavior: "smooth" });
  };
  
  const scrollToEstrutura = () => {
    const section = document.getElementById("estrutura");
    section.scrollIntoView({ behavior: "smooth" });
  };
  
  const scrollToDepoimentos = () => {
    const section = document.getElementById("depoimentos");
    section.scrollIntoView({ behavior: "smooth" });
  };
  
  return (
    <>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "internal",
          route: "/pages/ajuda/contate-nos",
          label: "Contate-nos",
          color: "info",
        }}
        sticky
      />

      <MKBox
        minHeight="40vh"
        width="100%"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.6),
              rgba(gradients.dark.state, 0.6)
            )}, url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <Grid
            container
            item
            xs={12}
            lg={8}
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            sx={{ mx: "auto", textAlign: "center" }}
          >
            <MKTypography variant="h1" color="white" opacity={0.8} mt={10} mb={3}>
              International Cyber Security Executive MBA
            </MKTypography>
            <MKTypography variant="body1" color="white" opacity={0.8} mt={1} mb={3}>
              Através de nossa parceria com a Templar Executives, e universidades do Reino Unido, nós oferecemos o MBA
              em segurança cibernética focado em executívos, militares e profissionais de alto-escalão.
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
      <br />
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
      <MKBox py={{ xs: 6, sm: 12 }} sx={{mx: { xs: 2, lg: 3 },mt: -8,}} component="section">
        <Container>
          <Grid container item xs={"auto"} justifyContent="left" mx="auto">
            <Grid container justifyContent="left" py={"auto"}>
              <Grid>
                <MKBox display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                  <MKTypography>
                    O <strong>Cyber Security Executive Masters of Business Administration (CEMBA)</strong> é um programa de pós-graduação de meio período, líder no setor, criado para capacitar os líderes atuais com as habilidades necessárias para se destacarem na era digital em constante evolução.
                    <br /><br />
                    Ministrado pela Lancaster University em parceria com a Templar Executives, o CEMBA é o primeiro do gênero a ser credenciado pelo National Cyber Security Centre (NCSC).
                    <br /><br />
                    Também oferecemos o International Cyber Executive MBA (iCEMBA), em parceria com outras renomadas universidades do Reino Unido e universidades brasileiras.
                  </MKTypography>
                </MKBox>
              </Grid >
            </Grid >
          </Grid >
        </Container>
      </MKBox>

      <MKBox component="section" py={2}>
      <Container>
        <Grid container spacing={3} mb={6}>
          <Grid item xs={12} md={6} lg={4}>
            <ColoredBackgroundCard
              image="https://templarexecs.com/wp-content/uploads/2024/03/CEMBA-Website-Visual10.png"
              label="Parceria"
              title="Templar ICEMBA"
              description="A Templar Executives tem a liderança neste MBA focado em Segurança Cibernética."
              color="warning"
              action={{
                type: "external",
                route: "https://templarexecs.com/what-we-do/training-and-awareness/cemba/",
                label: "Saiba mais",
              }}
            />
          </Grid>
          <Grid container spacing={3} item xs={12} md={6} lg={8}>
            <Grid item xs={12} md={6}>
              <InfoBackgroundCard
                image={image2}
                icon="import_contacts"
                title="Universidade de Lancaster"
                label={<
                  a href="https://www.lancaster.ac.uk/study/postgraduate/postgraduate-courses/cyber-security-executive-mba-mba/2025/" 
                  style={{ 
                        textDecoration: "none",
                        color: "inherit" 
                      }}>
                      Saiba mais
                      </a>}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <InfoBackgroundCard
                image={image1}
                icon="import_contacts"
                title="Requisitos"
                label={<
                  a href="https://www.lancaster.ac.uk/study/postgraduate/postgraduate-courses/cyber-security-executive-mba-mba/2025/#course-entry" 
                  style={{ 
                        textDecoration: "none",
                        color: "inherit" 
                      }}>
                      Saiba mais
                      </a>}
              />
            </Grid>
            {/*
            <Grid item xs={12} md={6}>
              <InfoBackgroundCard
                image={image1}
                icon="import_contacts"
                title="Requisitos"
                label={
                  <a href="#"
                  onClick={scrollToRequisitos}
                    style={{ 
                        textDecoration: "none",
                        color: "inherit" 
                    }}
                  >Saiba mais</a>
                }
              />
            </Grid>
            */}
            <Grid item xs={12} md={6}>
              <InfoBackgroundCard
                image={image3}
                icon="import_contacts"
                title="Estrutura"
                label={<a href="#"
                  onClick={scrollToEstrutura}
                    style={{ 
                        textDecoration: "none",
                        color: "inherit" 
                    }}
                  >Saiba mais</a>}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <InfoBackgroundCard
                image={image4}
                icon="import_contacts"
                title="Depoimentos"
                label={<a href="#depoimentos"
                  onClick={scrollToDepoimentos}
                    style={{ 
                        textDecoration: "none",
                        color: "inherit" 
                    }}
                  >Saiba mais</a>}
              />
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </MKBox>

    <StatsOne />
    
    <abanav value={1} />

    <Requirements id="requisitos" />
    
    <MKBox id="estrutura">
      <ICEMBAStructure />
    </MKBox>
    
    <MKBox id="depoimentos">
        {/* <Testimonials id="depoimentos" /> */}
    </MKBox>
    </Card>
    <MKBox pt={6} px={1} mt={6}>
        <FMPFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default Icemba;
